import React from 'react'

/**
 * Generic error boundary. Renders `fallback` (default: nothing) when a child
 * throws, so an isolated widget failure can't take down the surrounding page.
 *
 * Usage:
 *   <ErrorBoundary fallback={null}><RiskyWidget /></ErrorBoundary>
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    if (this.props.onError) this.props.onError(error, info)
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught an error:', error, info)
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback !== undefined ? this.props.fallback : null
    }
    return this.props.children
  }
}
